import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import jsPDF from 'jspdf';

@InjectModule({ stateFactory: true }, module)
export default class PdfModule extends InjectVuexModule {
    public pdfPages: string[] = [];

    @Mutation
    public addPage(pageImage: string) {
        this.pdfPages.push(pageImage);
    }

    @Mutation
    public clearPages() {
        this.pdfPages = [];
    }

    @Action({ rawError: true })
    public async storePages(screenshots: string[]) {
        screenshots.forEach(screenshot => {
            this.addPage(screenshot);
        });
    }

    @Action({ rawError: true })
    public async generatePdf() {
        if (this.pdfPages.length === 0) {
            console.warn('No pages captured yet.');
            return;
        }

        // **Set jsPDF to use high-quality PDF format (higher DPI)**
        const pdf = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            compress: true, // **Enables better image compression**
        });

        const pageWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const marginTop = 5;
        const marginBottom = 5;

        for (let index = 0; index < this.pdfPages.length; index++) {
            if (index > 0) pdf.addPage();

            const imgData = this.pdfPages[index];

            // Create a temporary image to get the original dimensions
            const img = new Image();
            img.src = imgData;
            await new Promise(resolve => (img.addEventListener('load', resolve))); // Wait for image to load

            const imgWidth = img.width;
            const imgHeight = img.height;

            // Fit image inside A4 dimensions with high DPI
            let finalWidth = pageWidth - 10;
            let finalHeight = (finalWidth / imgWidth) * imgHeight;

            if (finalHeight > pageHeight - (marginTop + marginBottom)) {
                finalHeight = pageHeight - (marginTop + marginBottom);
                finalWidth = (finalHeight / imgHeight) * imgWidth;
            }

            // Set high DPI resolution for image rendering
            const xPos = (pageWidth - finalWidth) / 2;
            const yPos = marginTop;

            pdf.addImage(imgData, 'PNG', xPos, yPos, finalWidth, finalHeight, undefined, 'FAST'); // **Higher rendering quality**
        }

        // pdf.save('Summary.pdf');
        // this.clearPages();
        return pdf;
    }
}
